import requestProvider from "./axiosHandler";

const base = 'inventory/'

const createAll = (list) => {
    return requestProvider
        .post(`${base}create-all`, list)
}

const getStockInformation = (id) => {
    return requestProvider
        .get(`${base}get-by-stockid/${id}`)
}

export {createAll, getStockInformation}